export default {"src":"/_next/static/media/drag_indicator.1ab6ca43.svg","height":40,"width":40};